// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1epCD","bottom":"Note_bottom__lAuix","author":"Note_author__37tD9","author__name":"Note_author__name__3uNvI","datetime":"Note_datetime__2xKLj"};